<nav id="header-content" class="bg-white border-b-offwhite border-b-2 px-4">
  <div class="container mx-auto">
    <div class="min-h-[70px] flex justify-between items-center">
      <div class="flex items-center">
        <div
          class=""
          [ngClass]="[
            !!shortName ? 'border-r-2 border-r-gray-400 pr-2 mr-2' : ''
          ]"
        >
          <img
            [src]="logo"
            alt="enugu east lga logo"
            class="auth-logo flex w-[40px]"
          />
        </div>
        <a class="!text-black !font-bold truncate text-sm max-[w-100px]">
          NYGA</a
        >
      </div>

      <div class="flex items-center">
        <div [ngClass]="{ 'expand-menu': sideMenu }">
          <div
            class="backdrop hidden transition delay-150 duration-300 ease-in-out"
            (click)="toggleMenu()"
          ></div>
          <div class="sidebar bg-white">
            <div class="flex justify-end mb-3 md:hidden">
              <button (click)="toggleMenu()">
                <ion-icon
                  name="close-outline"
                  class="text-[32px] text-red-500"
                ></ion-icon>
              </button>
            </div>
            <ul class="items-center md:flex bg-white">
              <li
                class="ml-5 cursor-pointer text-sm text-black"
                *ngFor="let menu of menuItems"
                [routerLink]="menu.route"
                [routerLinkActiveOptions]="{
                  exact: menu.routeExact
                }"
                routerLinkActive="router-active"
              >
                {{ menu.title | titlecase }}
              </li>
            </ul>
          </div>
        </div>
        <div class="flex items-center">
          <button
            class="ml-8 cursor-pointer text-[24px] mt-1"
            [routerLink]="'/profile'"
            routerLinkActive="text-primary"
          >
            <ion-icon name="person-circle-outline"></ion-icon>
          </button>
          <button menu="sideMenu" class="md:hidden ml-5" (click)="toggleMenu()">
            <ion-icon name="grid-outline"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>
